//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import Hamburger from '@/components/Hamburger'
import { getRouter } from '@/utils/storage'
export default {
  components: { SidebarItem, Hamburger },
  data () {
    return {
      defaultActive: ''
    }
  },
  computed: {
    ...mapGetters([
      'menus',
      'sidebar',
      'theme',
      'recodeMenu'
    ]),
    isCollapse () {
      return !this.sidebar.opened
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler (to) {
        let menuId = to.query.resource
        let freshTime = to.query.time
        if (to.fullPath === '/dashboard') {
          this.defaultActive = 'dashboard'
          return
        }
        if (menuId && freshTime) {
          let href = ''
          for (let i = 0; i < this.recodeMenu.length; i++) {
            if (menuId == this.recodeMenu[i].menuId) {
              href = this.recodeMenu[i].href
              break
            }
          }
          if (href) {
            this.defaultActive = href
          }
        } else {
          this.defaultActive = getRouter().href
        }
      }
    }
  },
  created () {
    window.addEventListener('message', this.listenBpmMessage)
  },
  destroyed () {
    window.removeEventListener('message', this.listenBpmMessage)
  },
  methods: {
    listenBpmMessage (e) {
      var data = e.data
      if (data === 'bpm:start_process' || data === 'bpm:approve_process') {
        this.$refs.menuItem.selectMmenu(true)
      }
    },
    toggleSideBar () {
      this.$store.dispatch('toggleSideBar')
    },
    // defaultActive () {
    //   var router = getRouter()
    //   return router.href
    // },
    handleSelect (key, keyPath) {
      // if (key == '/importAttendanceRecord') {
      //   this.$router.push({ name: 'importAttendanceRecord', href: key, query: { time: String(new Date().getTime()) } })
      // }else if(key == '/attendanceRecordSeach'){
      //   this.$router.push({ name: 'attendanceRecordSeach', href: key, query: { time: String(new Date().getTime()) } })
      // }else if(key == '/monthAttendanceRecordSeach'){
      //   this.$router.push({ name: 'monthAttendanceRecordSeach', href: key, query: { time: String(new Date().getTime()) } })
      // }else if (key == '/checkCalendar') {
      //   this.$router.push({ name: 'checkCalendar', href: key, query: { time: String(new Date().getTime()) } })
      // }else if (key == '/retroactive') {
      //   this.$router.push({ name: 'retroactive', href: key, query: { time: String(new Date().getTime()) } })
      // }
      this.$refs.menuItem.selectMmenu()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/layout/components/Sidebar/index.vue